export default __webpack_public_path__ + "static/media/ArrowUp.9db34f47.svg";